<template>
  <component :is="supplierData === undefined ? 'div' : 'b-card'">
    <b-alert variant="danger" :show="supplierData === undefined">
      <h4 class="alert-heading">獲取供應商數據時出錯</h4>
      <div class="alert-body">
        找不到相關供應商記錄。請查看
        <b-link class="alert-link" :to="{ name: 'suppliers-list' }">
          供應商名單
        </b-link>
      </div>
    </b-alert>
    <supplier-edit-tab-information
      v-if="supplierData"
      :bank-options="bankOptions"
      :payment-method-status-options="paymentMethodStatusOptions"
      :supplier-data="supplierData"
      @refetch-data="refetchData"
      class="p-sm-2"
    />
  </component>
</template>

<script>
import { BCard, BAlert, BLink, BTabs, BTab } from "bootstrap-vue";
import { ref, onUnmounted, onMounted } from "@vue/composition-api";
import store from "@/store";
import router from "@/router";
import supplierStoreModule from "../supplierStoreModule";
import SupplierEditTabInformation from "./supplierEditTabInformation.vue";

export default {
  components: {
    SupplierEditTabInformation,
    BCard,
    BAlert,
    BTabs,
    BTab,
    BLink,
  },
  setup() {
    const supplierData = ref({id: 0, is_active: 0});
    const supplier = {
      id: 0,
      is_active: 0,
    };

    const Supplier_APP_STORE_MODULE_NAME = "supplier";

    if (!store.hasModule(Supplier_APP_STORE_MODULE_NAME))
      store.registerModule(Supplier_APP_STORE_MODULE_NAME, supplierStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(Supplier_APP_STORE_MODULE_NAME))
        store.unregisterModule(Supplier_APP_STORE_MODULE_NAME);
    });

    const refetchData = () => {
      if (router.currentRoute.name == "supplier-create") {
        supplierData.value = supplier;
      } else {
      
        store
          .dispatch("supplier/fetchSupplier", { id: router.currentRoute.params.id })
          .then((response) => {
            supplierData.value = response.data.entity;
            console.log(supplierData.value)
          })
          .catch((error) => {
            console.log("error when fetching supplier", error);
            if (error.response.status === 404) {
              supplierData.value = undefined;
            }
          });
      }
    };

    const bankOptions = ref([]);
    const paymentMethodStatusOptions = ref([]);

    const refetchOption = () => {
      store
        .dispatch("app/fetchOptionList", {
          banks: true,
          payment_methods: true,
        })
        .then((response) => {
          bankOptions.value = response.data.banks;
          paymentMethodStatusOptions.value = response.data.payment_methods;
        });
    };


    onMounted(() => {
      refetchData();
      refetchOption();
    });

    return {
      supplierData,
      bankOptions,
      paymentMethodStatusOptions,
      refetchOption,
      refetchData
    };
  },
};
</script>
